export class FormControlMock {
    readonly nativeElement: HTMLInputElement;

    constructor(type: string = 'text') {
        this.nativeElement = document.createElement('input');
        this.nativeElement.setAttribute('type', type);
    }
}
